import React from 'react';
import './Schedina.css';
import RigaEvento from './RigaEvento';
import TabellaSistema from './TabellaSistema';
import BloccoSoldi from './BloccoSoldi';
import {combinazioni as quanteCombinazioni} from '../../services/profiloDiGioco';
import Impostazioni from './Impostazioni';
import { passoBonus } from '../../services/profiloDiGioco';
import Prenotazione from './Prenotazione';
import {cambioQuota as cambioQuotaCorrente, impostaCambioQuota,
  impostaPredefinitiSchedina, ascolta, lingua } from '../../preferenze';
import {schedina as moduloSchedina} from '../../moduli/leggi';
import {
  esitiPerEvento,
  colonneIntegrale,
  colonneSistema,
  riassunto,
  bonusColonna,
  quoteCheContano,
  arrotonda,
  ripartisci,
  totaleRiga,
  limitiDi,
  tipoCouponDa,
  bancoChiuso,
  massimiInVigore,
  tettiSforati,
} from '../../services/profiloDiGioco';
import { mostraQuota, formattaOra, siglaFuso } from '../../utils/formato';
import i18next from 'i18next';
import {mancaMolteplicita, regoleMolteplicita} from '../../services/molteplicita';

const euro = (n) => Number(n || 0).toLocaleString(lingua(), {
  minimumFractionDigits: 2, maximumFractionDigits: 2,
});

/**
 * LA SCHEDINA.
 *
 * Tutto quello che si vede qui dentro arriva dal profilo di gioco: importi
 * rapidi, tabella del bonus, prenotazione, limiti. Niente si inventa — se un
 * valore non c'e', il controllo corrispondente non si fa, e se il profilo non
 * arriva affatto la giocata non parte e lo si dice.
 *
 * Il contratto sta in lvc-docs/it/profilo-di-gioco.md.
 */
/**
 * LA COLONNA PIU' MAGRA di una grandezza: le fisse, piu' le libere con la
 * quota piu' bassa. E' quella che prende lo scalino piu' basso di tutte, ed e'
 * di lei che parla la riga del bonus: cosi' quello che c'e' scritto vale per
 * ogni colonna, non solo per la piu' fortunata.
 */
function colonnaPiuMagra(quote, chiaviFisse, k) {
  const fisse = (quote || []).filter((q) => chiaviFisse.indexOf(q.chiave) !== -1);
  const libere = (quote || []).filter((q) => chiaviFisse.indexOf(q.chiave) === -1)
      .slice()
      .sort((a, b) => a.valore - b.valore);
  const quante = k - fisse.length;
  if (quante < 0 || quante > libere.length) return null;
  return fisse.concat(libere.slice(0, quante));
}

export default function Schedina({
  selezioni,
  profilo,
  chi,                     // 'ospite' | 'giocatore' | 'agenzia'
  giocatori,
  giocatoreScelto,
  onGiocatore,
  motivoProfilo,
  giroAutomatico,
  onGiro,
  onTogli,
  onSvuota,
  onGioca,
  onPrenota,
  /* La giocata prenotata, quando c'e': `pronta: true` col codice e la
     scadenza, oppure `pronta: false` col motivo scritto -- la maschera e' la
     stessa e dice cosa non e' andato, invece di un pulsante che non fa
     niente. */
  prenotata,
  /* Le regole di stampa e condivisione di chi guarda, per la maschera della
     prenotazione (null = la maschera di sempre). */
  regoleStampa = null,
  regoleInArrivo = false,
  onChiudiPrenotata,
  onCodice,
  /* L'importo che arriva con una prenotazione riaperta: {importo, chiave}.
     Si scrive nella casella UNA volta per chiave, poi la casella e' di chi
     compila. */
  importoProposto,
  inCorso,
  esito,
}) {
  const [tipoScelto, setTipoScelto] = React.useState('multipla');
  const [importo, setImporto] = React.useState('');
  const [fisse, setFisse] = React.useState([]);
  const [importiSistema, setImportiSistema] = React.useState({});
  /* Quali grandezze si giocano. La SPUNTA lo dice, non l'importo: usare
     l'importo come interruttore vuol dire che cancellandolo per correggerlo
     la riga esce dal conto senza che nessuno l'abbia deciso. */
  const [attive, setAttive] = React.useState([]);
  /* L'IMPORTO TOTALE del sistema. Si puo' giocare in due modi e devono
     convivere: o si scrive quanto va su ogni colonna, riga per riga, o si
     scrive quanto si vuole spendere in tutto e lo divide lui. Chi gioca
     sistemi grossi ragiona quasi sempre nel secondo modo -- "ci metto
     cinquanta euro" -- e prima qui si poteva solo il primo. */
  const [importoTotale, setImportoTotale] = React.useState('');
  /* Quante colonne di ogni riga prendono il centesimo in piu'.
     Sta accanto agli importi e non dentro, perche' l'importo e' quello che si
     scrive e si legge, questo e' il resto della divisione: due euro su sei
     colonne sono quattro colonne a 0,33 e due a 0,34, e senza tenere il conto
     di quelle due il totale tornerebbe 1,98. */
  const [centesimi, setCentesimi] = React.useState({});
  const [codice, setCodice] = React.useState('');

  const propostaScritta = React.useRef(null);
  React.useEffect(() => {
    if (!importoProposto || !importoProposto.chiave) return;
    if (propostaScritta.current === importoProposto.chiave) return;
    propostaScritta.current = importoProposto.chiave;
    if (Number(importoProposto.importo) > 0) {
      setImporto(String(importoProposto.importo));
    }
  }, [importoProposto]);

  const gruppi = React.useMemo(() => esitiPerEvento(selezioni), [selezioni]);
  const quote = React.useMemo(
      () => gruppi.map((g) => g.quote).reduce((a, b) => a.concat(b), []), [gruppi]);

  /* LE FISSE CHE ESISTONO ANCORA, e da qui in giu' si usano solo queste.
     Togliere dal palinsesto una partita che era fissa lasciava la sua chiave
     nell'elenco: nessuna B risultava premuta, ma il conto delle fisse restava
     quello di prima. E le due strade che portano alle colonne non usano la
     stessa cosa -- quante combinazioni fa una riga si calcola dal NUMERO
     delle fisse, quali colonne escono si calcola dalle CHIAVI -- quindi una
     chiave morta le faceva rispondere due numeri diversi.
     Si vedeva in faccia: "0,50 per colonna x 4" e sotto "Totale impegnato 6
     colonne 3,00". Il giocatore ne aveva scritti 2. */
  const chiaviVive = React.useMemo(() => quote.map((q) => q.chiave), [quote]);
  const fisseVive = React.useMemo(
      () => fisse.filter((c) => chiaviVive.indexOf(c) !== -1), [fisse, chiaviVive]);

  /* Le righe del sistema che hanno ancora senso: una grandezza piu' piccola
     del numero di fisse non esiste, e nemmeno una piu' grande delle
     selezioni rimaste. Restavano spuntate e contavano nei soldi anche dopo
     essere sparite dalla tabella. */
  const rigaEsiste = React.useCallback(
      (k) => k >= fisseVive.length && k <= quote.length
          && quanteCombinazioni(quote.length, fisseVive.length, k) > 0,
      [quote.length, fisseVive.length]);
  const attiveVive = React.useMemo(
      () => attive.filter(rigaEsiste), [attive, rigaEsiste]);

  /* Quello che non esiste piu' si butta via davvero, non si ignora soltanto:
     finche' resta nello stato ricompare appena la struttura torna com'era, e
     l'importo di una riga sparita si ritrova addosso a una riga nuova. */
  React.useEffect(() => {
    if (fisseVive.length !== fisse.length) setFisse(fisseVive);
  }, [fisseVive, fisse.length]);

  React.useEffect(() => {
    if (attiveVive.length === attive.length) return;
    setAttive(attiveVive);
    const morte = attive.filter((k) => attiveVive.indexOf(k) === -1);
    setImportiSistema((p) => scarta(p, morte));
    setCentesimi((p) => scarta(p, morte));
  }, [attiveVive, attive]);

  /* IL TIPO SI DEDUCE DALLA STRUTTURA, non si dichiara: piu' esiti sullo
     stesso evento significa per forza integrale, perche' una multipla
     richiede che tutte le selezioni si verifichino insieme. */
  const eventoDoppiato = gruppi.find((g) => g.quote.length > 1);
  const integrale = Boolean(eventoDoppiato);
  const tipo = integrale ? 'integrale' : tipoScelto;

  /* LA SPUNTA DEL CAMBIO QUOTA.
     Prima si leggeva dal profilo a ogni invio e il giocatore non poteva
     toccarla: adesso e' uno stato suo, e il profilo e' il PUNTO DI PARTENZA,
     non la decisione -- dal backoffice parte tutto, ma chi gioca decide la
     sua giocata. Dura finche' e' collegato: chi la toglie la toglie per un
     motivo, e rimettergliela a ogni schedina sarebbe un dispetto.
     Dall'8/10 la spunta sta nelle PREFERENZE (preferenze.js), non qui: la
     finestra Impostazioni e' una sola e puo' stare anche in testata (modulo
     Schedina › rotellina), e le due devono leggere lo stesso valore. Qui si
     scrive il predefinito del profilo e si legge la spunta com'e'; il
     profilo non riscrive una scelta gia' fatta (la scelta vince, in
     preferenze.js). */
  const [impostazioniAperte, setImpostazioniAperte] = React.useState(false);
  const predefinitoQuota = Boolean(profilo && profilo.cambioQuota
      && profilo.cambioQuota.predefinito);
  const includeRiproposta = Boolean(profilo && profilo.cambioQuota
      && profilo.cambioQuota.includeRiproposta);

  React.useEffect(() => {
    impostaPredefinitiSchedina({cambioQuota: predefinitoQuota, includeRiproposta});
  }, [predefinitoQuota, includeRiproposta]);

  /* Si ridisegna quando la spunta cambia dall'altra parte (testata). */
  const [, ridisegna] = React.useState(0);
  React.useEffect(() => ascolta(() => ridisegna((n) => n + 1)), []);
  const cambioQuota = cambioQuotaCorrente();
  /* Dove sta la rotellina lo dice il modulo Schedina: qui, in testata, o tutte e due. */
  const rotellinaQui = moduloSchedina().rotellina !== 'testata';

  const scalini = (profilo && profilo.bonusMultipla && profilo.bonusMultipla.scalini) || [];
  /* Oltre quanti giorni una partita non conta per arrivare allo scalino.
     Nullo = nessun limite. Resta nella giocata e moltiplica lo stesso: qui
     cambia solo il CONTEGGIO, ed e' lo stesso filtro che fa il server. */
  const giorniBonus = (profilo && profilo.bonusMultipla
      && profilo.bonusMultipla.giorniMassimi) || null;
  const limiti = limitiDi(profilo, tipoCouponDa(tipo, selezioni.length));

  /* IL BANCO CHIUSO. Quando il banco della skin e' chiuso -- per la fascia
     notturna, o perche' qualcuno l'ha chiuso a mano -- la riserva non esiste:
     le soglie che di giorno mandano la giocata da una persona diventano
     tetti, e sopra non si gioca. Di giorno quei tetti non ci sono, quindi chi
     compila non puo' saperli: vanno scritti QUI, mentre compila, non fatti
     scoprire con un rifiuto. Quali sono e quanto valgono lo dice il profilo;
     qui non si calcola niente e non si guarda l'orologio.

     Vale per chi puo' MANDARE una giocata: il giocatore, e l'agenzia che
     compila per lui. Chi puo' solo prenotare non ha tetti da leggere --
     prenotare non e' giocare, i limiti si guardano quando la prenotazione
     viene giocata. */
  const notte = bancoChiuso(
      chi === 'giocatore' || chi === 'agenzia' ? profilo : null, limiti);

  /* I MASSIMI CHE VALGONO ADESSO, scritti sotto l'importo mentre si compila:
     «Importo massimo 500,00 € · Vincita massima 1.000,00 € · massimo 10
     partite». Di giorno e a banco chiuso, con gli stessi nomi e lo stesso
     posto: a banco chiuso il profilo porta gia' i numeri della notte. Sono
     solo quelli che fermano o tagliano davvero -- una soglia con «riserva»
     di giorno non e' un limite, e non si scrive. Li legge chi puo' mandare
     una giocata, come i tetti della notte. */
  const massimi = chi === 'giocatore' || chi === 'agenzia'
      ? massimiInVigore(limiti) : [];

  /* CHE COSA LEGGE IL GIOCATORE A BANCO CHIUSO lo sceglie la skin
     (Impostazioni schedina, tendina 7) e lo dice il profilo (`alGiocatore`):
       solo i limiti (di serie)  niente «Banco chiuso»: i tetti della notte
                                 stanno nella riga dei massimi come di
                                 giorno, e le righe sotto il tasto sono
                                 quelle di giorno
       banco chiuso e i limiti   la striscia «Banco chiuso · Adesso si gioca
                                 fino a...», e le righe sotto il tasto
                                 dicono «Adesso»
       ... e l'ora               la striscia con «riapre alle», e le righe
                                 con «oppure riprova dalle»
     Un servizio vecchio non manda il campo: la striscia, com'era prima. */
  const striscia = notte.chiuso && notte.tetti.length > 0
      && notte.alGiocatore !== 'SOLO_LIMITI';

  // ---- i conti ---------------------------------------------------------

  const grandezze = attiveVive.filter((k) => Number(importiSistema[k]) > 0);

  /* Quante colonne fanno le righe SPUNTATE, importo o non importo: e' il
     divisore del totale, e deve esistere anche prima che un importo sia
     stato scritto, altrimenti scrivere il totale per primo non farebbe
     niente. */
  const colonneSpuntate = attiveVive
      .map((k) => quanteCombinazioni(quote.length, fisseVive.length, k))
      .reduce((a, b) => a + b, 0);

  /* Spalma il totale su tutte le colonne spuntate, SENZA PERDERNE UN
     CENTESIMO. La base va a tutte, e i centesimi che avanzano vanno uno a
     testa alle prime colonne -- lo stesso conto che fa il server quando
     sviluppa le combinazioni. Chi scrive 2 gioca 2, non 1,98.

     I centesimi si distribuiscono per riga nell'ordine in cui le righe
     stanno: la prima se ne prende quanti ne ha di colonne, poi la seconda, e
     cosi' via finche' finiscono. Quale colonna se lo prende non cambia il
     totale, che e' quello che conta. */
  const spalma = React.useCallback((totale, righe, colonneDi) => {
    const ordinate = righe.slice().sort((a, b) => a - b);
    const quanteInTutto = ordinate
        .map(colonneDi).reduce((a, b) => a + b, 0);
    const parti = ripartisci(totale, quanteInTutto);

    setImportiSistema((precedenti) => {
      const nuovi = Object.assign({}, precedenti);
      ordinate.forEach((k) => {
        nuovi[k] = parti.base > 0 ? String(parti.base) : '';
      });
      return nuovi;
    });

    setCentesimi(() => {
      const nuovi = {};
      let restano = parti.extra;
      ordinate.forEach((k) => {
        const quante = colonneDi(k);
        const suQuesta = Math.min(restano, quante);
        nuovi[k] = suQuesta;
        restano -= suQuesta;
      });
      return nuovi;
    });
  }, []);

  /* Cambiare le spunte o le fisse cambia QUANTE colonne ci sono, quindi il
     totale va rispalmato: il totale e' quello che il giocatore ha chiesto di
     spendere, e deve restare quello anche se le colonne raddoppiano. */
  const ultimaSpalmata = React.useRef('');
  React.useEffect(() => {
    const t = Number(importoTotale);
    if (!(t > 0)) return;
    const firma = `${importoTotale}|${colonneSpuntate}|${attiveVive.join(',')}`;
    if (ultimaSpalmata.current === firma) return;
    ultimaSpalmata.current = firma;
    spalma(t, attiveVive, (k) => quanteCombinazioni(quote.length, fisseVive.length, k));
  }, [importoTotale, colonneSpuntate, attiveVive, spalma,
    quote.length, fisseVive.length]);

  let tre = null;
  let quotaSemplice = 0;
  let bonusSemplice = 0;
  let vincitaSemplice = 0;

  if (integrale) {
    tre = riassunto(colonneIntegrale(gruppi), Number(importo) || 0, scalini, giorniBonus);
  } else if (tipo === 'sistema' && grandezze.length > 0) {
    // Ogni grandezza ha il suo importo: si riassume su tutte insieme, perche'
    // la vincita di un sistema e' la somma delle colonne che vincono.
    /* Ogni colonna porta il SUO importo, non quello della sua riga: dentro la
       stessa riga le prime prendono un centesimo in piu'. Un centesimo su una
       quota da 1.400 sono quattordici euro di differenza sulla vincita, quindi
       non e' un dettaglio che si puo' arrotondare via. */
    const tutte = [];
    grandezze.forEach((k) => {
      const base = Number(importiSistema[k]) || 0;
      const piu = Number(centesimi[k]) || 0;
      colonneSistema(quote, fisseVive, [k]).forEach((c, i) => {
        tutte.push({ colonna: c, importo: arrotonda(base + (i < piu ? 0.01 : 0)) });
      });
    });
    tre = riassuntoMisto(tutte, scalini, giorniBonus);
  } else {
    const valori = quote.map((q) => q.valore);
    quotaSemplice = arrotonda(valori.reduce((a, b) => a * b, 1));
    // La quota le moltiplica TUTTE; il bonus conta solo quelle che contano.
    bonusSemplice = bonusColonna(quotaSemplice, Number(importo) || 0,
        quoteCheContano(quote, giorniBonus), scalini);
    vincitaSemplice = arrotonda(quotaSemplice * (Number(importo) || 0)) + bonusSemplice;
  }

  /* Quante partite contano e quante restano fuori lo dice adesso `passo`,
     qui sotto, e lo dice sulla COLONNA invece che sulle selezioni della
     schedina: su un integrale con tre fisse e cinque esiti sono otto
     selezioni ma quattro partite per colonna, e il vecchio conto scriveva
     otto. */
  /* DUE RAGIONI DIVERSE PER RESTARE FUORI, e vanno distinte: una partita
     troppo lontana e una quota troppo bassa non si sistemano allo stesso
     modo. Le tiene separate `passo.fuoriPerData`, e la riga del bonus le
     scrive come due frasi diverse. */

  /* ------------------------------------------------------------------
     LA RIGA DEL BONUS: a che punto sei della tabella, e cosa costa il passo
     dopo. La schedina dice gia' QUANTO bonus; non ha mai detto PERCHE' quello
     ne' COSA MANCA, ed e' la domanda che si fa chiunque veda zero.

     SI PARLA SEMPRE DELLA COLONNA PIU' MAGRA. Su un integrale e su un sistema
     le colonne non sono tutte uguali: prendere la migliore vorrebbe dire
     scrivere una percentuale che qualche colonna non prende. La riga non
     promette mai piu' di quello che prende la colonna peggiore.
     ------------------------------------------------------------------ */
  let passo = null;
  if (scalini.length > 0 && quote.length > 1) {
    let colonna = null;
    if (integrale) {
      // Un esito per gruppo, il piu' basso: la colonna che paga meno.
      colonna = gruppi
          .map((g) => (g.quote || []).reduce(
              (basso, q) => (basso === null || q.valore < basso.valore ? q : basso), null))
          .filter(Boolean);
    } else if (tipo === 'sistema') {
      /* La grandezza piu' piccola spuntata: e' quella che fa la domanda
         ("le quaterne prendono qualcosa?"), e le altre stanno sopra. */
      const piuPiccola = attiveVive.length ? Math.min.apply(null, attiveVive) : null;
      colonna = piuPiccola === null ? null : colonnaPiuMagra(quote, fisseVive, piuPiccola);
    } else {
      // Multipla: la colonna e' tutta la schedina.
      colonna = quote;
    }

    if (colonna && colonna.length > 0) {
      const contate = quoteCheContano(colonna, giorniBonus);
      const base = passoBonus(scalini, contate);
      if (base) {
        const doppiato = integrale && eventoDoppiato
            ? (selezioni || []).find((e) => e.eventId === eventoDoppiato.eventId)
            : null;
        passo = Object.assign({}, base, {
          tipo: integrale ? 'integrale' : (tipo === 'sistema' ? 'sistema' : 'multipla'),
          /* Quante partite ha una colonna, e quante ne restano fuori: sono
             due numeri diversi e il motivo si sistema in modo diverso. */
          totali: colonna.length,
          fuoriPerData: colonna.length - contate.length,
          /* L'INTEGRALE: aggiungere un altro esito sull'evento gia' doppiato
             NON allunga la colonna, raddoppia le colonne. Senza dirlo, chi
             legge "ti manca una partita" clicca e non succede niente. */
          eventoDoppiato: doppiato ? doppiato.matchName : null,
          /* IL SISTEMA: le grandezze spuntate che restano sotto il primo
             scalino non prendono niente, e sono quelle da nominare. */
          grandezzeSenza: tipo === 'sistema'
              ? attiveVive.filter((k) => k < Number(base.primo.eventi))
                  .slice().sort((a, b) => a - b)
              : [],
        });
      }
    }
  }

  /* QUANTO GRANDE DIVENTA LA GIOCATA DA SCRIVERE.
     Una giocata e' un documento solo, e un documento ha un tetto: con tutte
     le grandezze spuntate su venti selezioni si arriva a milioni di colonne,
     e la giocata non si riesce a registrare. Il numero non e' scritto qui --
     arriva dal profilo, come tutto il resto -- e serve a dirlo mentre si
     spuntano le righe invece di farlo scoprire premendo Gioca. */
  const tettoScritture = Number(
      (profilo && profilo.massimoSelezioniScritte) || 0);
  const selezioniDaScrivere = attiveVive.reduce(
      (n, k) => n + quanteCombinazioni(quote.length, fisseVive.length, k) * k, 0);
  const troppoGrande = tettoScritture > 0 && selezioniDaScrivere > tettoScritture;

  // ---- gli avvisi ------------------------------------------------------

  const avvisi = [];
  /* DA QUESTO LIVELLO NON SI GIOCA, MA SI PRENOTA.
     Sub-agente, agente, master, azienda non giocano per se' -- il server
     rifiuta -- e non compilano per altri, che e' mestiere dell'agenzia. Ma
     PRENOTARE non e' giocare: e' preparare una schedina e darne il codice a
     qualcuno, che poi la gioca con i SUOI soldi e i SUOI limiti. Un agente
     che prepara una giocata e la manda a un cliente sta facendo il suo
     mestiere.
     Quindi non si toglie niente: si dice qual e' lo strumento giusto. */
  if (chi === 'nonGioca') {
    avvisi.push({
      tipo: 'tetto',
      testo: i18next.t('Da questo livello non si gioca: prepara la schedina e manda il ')
          + i18next.t('codice a un giocatore.'),
    });
  }
  if (!profilo && chi !== 'ospite' && chi !== 'nonGioca') {
    /* IL CODICE E IL DETTAGLIO. "Riprova fra poco" non dice niente a nessuno:
       non al giocatore, che non sa se sia colpa sua, e non a chi deve
       sistemarlo, che si ritrova una segnalazione senza un appiglio. Il
       messaggio vero ce l'abbiamo -- lo manda il server -- e va scritto. */
    avvisi.push({
      tipo: 'blocco',
      testo: motivoProfilo
        ? `${motivoProfilo.message} · ${motivoProfilo.code}`
          + `${motivoProfilo.status ? ` (${motivoProfilo.status})` : ''}`
        : i18next.t('Limiti di gioco non disponibili in questo momento: riprova fra poco.'),
    });
  }
  /* I TETTI CHE QUESTA SCHEDINA SFORA: a banco chiuso tutti quelli della
     notte, e -- di giorno come di notte -- i massimi duri (importo, partite,
     e la vincita con «rifiuta»). Sopra, il tasto si spegne e una riga dice
     quale, col numero; prima di giorno lo diceva il servizio dopo «Gioca».
     L'importo e' il TOTALE della giocata, lo stesso numero che parte verso
     il servizio: su un integrale l'importo scritto per tutte le colonne, su
     un sistema la somma delle righe. Le partite sono gli EVENTI, non le
     selezioni: due esiti sulla stessa partita contano uno, come sul server. */
  const importoInTutto = tre ? tre.importoTotale
      : (tipo === 'sistema' ? 0 : Number(importo) || 0);
  const duri = massimi.filter((m) => m.ferma
      && !notte.tetti.some((t) => t.quale === m.quale));
  const sforati = tettiSforati(notte.tetti.concat(duri), {
    importo: importoInTutto,
    partite: gruppi.length,
    quote: quote.map((q) => q.valore),
    vincita: tre ? tre.vincitaTutte : vincitaSemplice,
  });

  if (limiti && limiti.vincitaMax != null) {
    const massima = tre ? tre.vincitaTutte : vincitaSemplice;
    const origine = (limiti.origine || {}).VINCITA_MAX || {};
    if (massima > Number(limiti.vincitaMax)) {
      /* Un tetto di vincita APPIATTISCE, per difetto: dice "oltre questa
         cifra non pago di più", non "questa giocata non la voglio". Il
         rifiuto è un'altra decisione e va scritta apposta sul vincolo —
         stessa regola del server, che è quello che comanda. */
      /* QUATTRO COMPORTAMENTI, E SOLO UNO FERMA LA GIOCATA.
         Prima RISERVA veniva trattata come RIFIUTO: la giocata era bloccata e
         il pulsante spento, cioe' esattamente il contrario di quello che dice
         il vincolo. Chi scrive "riserva" su un tetto ha chiesto di GUARDARE
         quella giocata, non di non riceverla, e bloccarla qui rendeva la
         riserva irraggiungibile dal sito.

         Il server e' quello che comanda, e fa queste quattro cose:
           RIFIUTO                  non si accetta
           APPIATTIMENTO            passa, la vincita si ferma al tetto
           RISERVA                  passa, la guarda una persona
           APPIATTIMENTO_E_RISERVA  entrambe, in quest'ordine */
      const appiattisce = origine.comportamento !== 'RIFIUTO'
          && origine.comportamento !== 'RISERVA';
      const laGuardaUnoperatore = origine.comportamento === 'RISERVA'
          || origine.comportamento === 'APPIATTIMENTO_E_RISERVA';

      /* Con «rifiuta» la riga la scrive il blocco dei massimi sforati, qui
         sotto, insieme agli altri: e' uno di quelli, di giorno come a banco
         chiuso, e due righe per lo stesso limite sarebbero la stessa cosa
         detta due volte. */
      if (appiattisce) {
        /* L'appiattimento va detto PRIMA, qui, non sulla ricevuta. E si dice
           SOLO il fatto e il numero: al giocatore non interessa quale nodo
           della rete ha messo il tetto, e dirglielo sarebbe pure raccontargli
           com'e' fatta la rete sopra di lui. Lo stesso nome della riga sotto
           l'importo: «Vincita massima», non un «tetto» che li' non c'e'. */
        avvisi.push({
          tipo: 'tetto',
          testo: i18next.t('Vincita massima {{v0}} €: la vincita ', {v0: euro(limiti.vincitaMax)})
              + i18next.t('la supera e viene portata al massimo.'),
        });
      }

      /* L'ACCETTAZIONE SI DICE PRIMA, come l'appiattimento: chi manda deve
         sapere che non parte subito, altrimenti vede la schedina svuotarsi e
         nessuna giocata in corso, e la rifa'. Non e' un blocco e non ha il
         colore di un blocco.
         Non si dice QUALE soglia l'ha fermata: quello resta al backoffice. */
      if (laGuardaUnoperatore) {
        avvisi.push({
          tipo: 'riserva',
          testo: i18next.t('Questa giocata la deve accettare un operatore: la mandi ')
              + i18next.t('adesso, l’importo viene impegnato subito e la risposta ')
              + i18next.t('arriva nella riga d’attesa.'),
        });
      }
    }
  }

  /* SOPRA UN MASSIMO IL TASTO SI SPEGNE, e una riga dice quale, col numero:
     «Importo massimo 500,00 €: riduci l'importo.» Di giorno e a banco chiuso
     nel modo «solo i limiti» la riga e' questa, e il giocatore non sa della
     notte. Con la striscia del banco chiuso la riga dice «Adesso ...», e
     l'ora in cui riapre si dice se c'e': c'e' solo nel modo «... e l'ora»
     (altrimenti il servizio non la manda) e solo se un'ora esiste -- un
     banco chiuso a mano su una skin senza fascia resta chiuso finche'
     qualcuno non riapre, e li' non se ne inventa una.

     SE IL SERVIZIO HA APPENA RIFIUTATO LA GIOCATA PER QUEL LIMITE la riga non
     si ripete: sopra c'e' gia' il suo rifiuto, che dice la stessa cosa col
     codice accanto. Il tasto resta spento lo stesso. */
  const riapreAlle = notte.riapre ? formattaOra(notte.riapre, 'ora') : '';
  const giaDetto = esito && !esito.buona && esito.limite ? esito.limite : null;
  sforati.forEach((t) => {
    avvisi.push({
      tipo: 'blocco',
      muto: t.quale === giaDetto,
      testo: fraseTetto(t, riapreAlle, Boolean(tre), striscia),
    });
  });

  /* LA MOLTEPLICITA' (2 novembre 2026): prima dell'invio, con la stessa
     frase che scriverebbe il servizio. Il numero arriva dal palinsesto e dal
     profilo; qui si conta e basta. Sui sistemi conta la colonna piu' piccola
     spuntata (le fisse ci sono gia' dentro). */
  const tipoMolt = tipo === 'sistema' ? 'sistema'
    : (tipo === 'integrale' ? 'integrale' : (selezioni.length === 1 ? 'singola' : 'multipla'));
  const piuPiccola = attiveVive.length ? Math.min.apply(null, attiveVive.map(Number)) : 0;
  const molt = mancaMolteplicita(selezioni, tipoMolt, regoleMolteplicita(profilo), piuPiccola);
  if (molt) {
    avvisi.push({tipo: 'blocco', testo: molt.testo});
  }

  const bloccata = avvisi.some((a) => a.tipo === 'blocco');
  /* Il tetto si passa al blocco dei soldi solo quando APPIATTISCE: se invece
     rifiuta, la giocata non parte e non c'e' niente da tagliare. */
  /* SI CONTROLLA ANCHE limiti, e non e' per prudenza: l'avviso di tipo
     'tetto' lo scrive anche il caso "questo conto non gioca", che per
     definizione non ha un profilo -- quindi limiti e' null e leggere
     limiti.vincitaMax farebbe cadere tutta la schedina. */
  const appiattito = (limiti && limiti.vincitaMax != null
      && avvisi.some((a) => a.tipo === 'tetto'))
      ? Number(limiti.vincitaMax) : null;

  // ---- i pulsanti ------------------------------------------------------

  /* Tutto quello che serve a comporre la giocata, in un oggetto solo: chi la
     manda non deve andare a ripescare lo stato di qui dentro. */
  function datiGiocata() {
    return {
      selezioni,
      tipo,
      importo,
      importiSistema,
      /* Quante colonne di ogni riga prendono il centesimo in piu': senza,
         chi compone la giocata rimoltiplica la base per le colonne e i
         centesimi avanzati spariscono -- una giocata da 2 euro registrata
         da 1,98. */
      centesimi,
      attive: attiveVive,
      chiaviFisse: fisseVive,
      accettaCambioQuota: Boolean(cambioQuotaCorrente()),
      combinazioniDi: (k) => (k === null
          ? (tre ? tre.colonne : 1)
          : quanteCombinazioni(quote.length, fisseVive.length, k)),
    };
  }

  const prenotabile = Boolean(profilo && profilo.prenotazione && profilo.prenotazione.attiva);

  /* PRENOTARE PARTE DAGLI STESSI DATI DI GIOCARE -- la stessa richiesta, lo
     stesso conto -- piu' la vincita che la maschera sta mostrando, che la
     prenotazione si porta dietro per il messaggio. */
  const prenota = () => onPrenota && onPrenota(Object.assign(datiGiocata(), {
    vincitaVista: tre ? tre.vincitaTutte : vincitaSemplice,
    /* Il riepilogo per la maschera del codice: a prenotazione fatta la
       schedina si svuota, e la maschera deve dire lo stesso cosa c'era. */
    riepilogo: {
      quante: quote.length,
      tipo: integrale ? 'integrale' : tipo,
      importo: tre ? tre.importoTotale : Number(importo) || 0,
      vincita: tre ? tre.vincitaTutte : vincitaSemplice,
    },
  }));
  const senzaGiocatore = chi === 'agenzia' && !giocatoreScelto;
  const nonGioca = chi === 'nonGioca';
  const importoScritto = tre ? tre.importoTotale > 0 : Number(importo) > 0;

  let primario;
  if (nonGioca) {
    /* Per chi non gioca, prenotare E' l'azione principale: e' l'unica cosa
       che ha senso fare qui, quindi sta nel posto dell'azione principale
       invece che come ripiego sotto un pulsante spento. */
    primario = {
      testo: inCorso ? i18next.t('Prenotazione in corso…') : i18next.t('Prenota la giocata'),
      onClick: prenota,
      attivo: prenotabile && importoScritto && !inCorso,
    };
  } else if (chi === 'ospite') {
    primario = {
      testo: inCorso ? i18next.t('Prenotazione in corso…') : i18next.t('Prenota la giocata'),
      onClick: prenota,
      attivo: prenotabile && importoScritto && !inCorso,
    };
  } else if (senzaGiocatore) {
    primario = { testo: i18next.t('Scegli prima il giocatore'), onClick: null, attivo: false };
  } else {
    /* Sul pulsante si legge la USERNAME, non l'identificativo che viaggia
       nella richiesta: "Gioca per 7f3a-91c2" non lo capisce nessuno. */
    const suo = (giocatori || []).find((g) => g.userId === giocatoreScelto);
    const nome = chi === 'agenzia' && giocatoreScelto
        ? ` per ${(suo && suo.username) || giocatoreScelto}` : '';
    /* IL PULSANTE DICE COSA FA. Quando la giocata deve passare da una
       persona non parte subito, e scriverci sopra "Gioca" e' una mezza
       verita': chi preme si aspetta la giocata in corso e trova una riga in
       attesa. L'avviso sopra lo spiega, ma il pulsante lo dice prima -- e
       chi preme un pulsante non sempre legge quello che ci sta sopra.
       E' la forma che il contratto del profilo di gioco chiede da sempre. */
    const daAccettare = avvisi.some((a) => a.tipo === 'riserva');

    primario = {
      testo: inCorso
          ? i18next.t('Invio in corso…')
          : troppoGrande
            ? i18next.t('Troppe colonne: togli una grandezza')
            : (daAccettare ? i18next.t('Invia per accettazione{{nome}}', {nome}) : `Gioca${nome}`),
      onClick: () => onGioca && onGioca(datiGiocata()),
      attivo: importoScritto && !bloccata && !inCorso && !troppoGrande,
    };
  }

  // ---- la giocata prenotata --------------------------------------------

  /* Prende il posto di tutto: a prenotazione fatta non c'e' piu' niente da
     comporre, e lasciare sotto la schedina viva fa ricominciare a toccare
     quote su una giocata gia' chiusa. */
  if (prenotata) {
    const r = prenotata.riepilogo;
    return (
      <div className="lvc-schedina">
        <Prenotazione
          stato={prenotata}
          quante={r ? r.quante : quote.length}
          tipo={r ? r.tipo : (integrale ? 'integrale' : tipo)}
          importo={r ? r.importo : (tre ? tre.importoTotale : Number(importo) || 0)}
          vincita={r ? r.vincita : (tre ? tre.vincitaTutte : vincitaSemplice)}
          regole={regoleStampa}
          regoleInArrivo={regoleInArrivo}
          onChiudi={onChiudiPrenotata}
        />
      </div>
    );
  }

  // ---- schedina vuota --------------------------------------------------

  if (!selezioni || selezioni.length === 0) {
    return (
      <div className="lvc-schedina">
        <div className="lvc-sched-testata"><span>{i18next.t('Schedina')}</span></div>
        <div className="lvc-sched-vuota">
          {/* LA GIOCATA APPENA FATTA. Andata a buon fine, la schedina si
              svuota: e la conferma col codice, che stava nel blocco dei soldi,
              spariva con lei. Chi non vede niente crede di non aver giocato e
              rigioca. Qui resta finche' non si sceglie un'altra quota. */}
          {esito && esito.buona && (
            <div className={'lvc-sched-avviso lvc-sched-avviso--' + (esito.attesa ? 'riserva' : 'fatta')}
              role="status">
              {esito.testo}
            </div>
          )}
          {i18next.t('Tocca una quota per cominciare.')}
          {/* Il campo del codice sta QUI, nella schedina vuota: e' l'unico
              posto dove non da' fastidio a nessuno, e chi arriva da un
              messaggio con un codice trova la schedina vuota. */}
          <div className="lvc-sched-codice">
            <label htmlFor="lvc-codice">{i18next.t('Hai un codice di una giocata prenotata?')}</label>
            <div className="lvc-sched-codice-riga">
              <input
                id="lvc-codice"
                value={codice}
                placeholder={i18next.t('es. 24FBBFED')}
                onChange={(e) => setCodice(e.target.value)}
              />
              <button type="button" onClick={() => onCodice && onCodice(codice.trim())}>
                {i18next.t('Apri')}
              </button>
            </div>
            {/* L'ESITO ANCHE QUI: un codice sbagliato o scaduto lascia la
                schedina vuota, e il motivo deve leggersi dove si e' premuto
                Apri -- non nel blocco dei soldi, che qui non c'e'. */}
            {esito && !esito.buona && (
              <div className="lvc-sched-avviso lvc-sched-avviso--blocco">{esito.testo}</div>
            )}
          </div>
        </div>
      </div>
    );
  }

  // ---- schedina piena --------------------------------------------------

  return (
    <div className="lvc-schedina">
      <div className="lvc-sched-testata">
        <span>{i18next.t('Schedina')}</span>
        <span className="lvc-sched-testata-dx">
          {rotellinaQui &&
            <Impostazioni
              aperta={impostazioniAperte}
              onApri={setImpostazioniAperte}
              cambioQuota={cambioQuota}
              onCambioQuota={(v) => impostaCambioQuota(v)}
              includeRiproposta={includeRiproposta}
            />}
          <span className="lvc-sched-conta">{quote.length}</span>
        </span>
      </div>

      {/* CHI GIOCA STA IN CIMA. Cambia il senso di tutto quello che sta
          sotto: di chi sono quei soldi e di chi e' quella scommessa. Solo i
          giocatori possono giocare: l'agenzia compila e paga, ma la
          scommessa resta intestata al giocatore. */}
      {chi === 'agenzia' && (
        <div className="lvc-sched-chi">
          <label htmlFor="lvc-giocatore">{i18next.t('Gioca per')}</label>
          <select
            id="lvc-giocatore"
            value={giocatoreScelto || ''}
            onChange={(e) => onGiocatore && onGiocatore(e.target.value)}
          >
            <option value="">{i18next.t('Scegli un giocatore')}</option>
            {(giocatori || []).map((g) => (
              /* SI VEDE la username, mai nome e cognome -- vale ovunque si
                 mostri un utente. Ma sul filo VIAGGIA l'identificativo: il
                 conto e' intestato a quello, e mandare il nome significava
                 chiedere al server di indovinare di chi si parla. */
              <option key={g.userId} value={g.userId}>
                {g.username} — {euro(g.saldo)} €
              </option>
            ))}
          </select>
          <label className="lvc-sched-giro">
            <input
              type="checkbox"
              checked={Boolean(giroAutomatico)}
              onChange={(e) => onGiro && onGiro(e.target.checked)}
            />
            {i18next.t('Giroconto automatico: gira solo la differenza che manca')}
          </label>
        </div>
      )}

      {/* CHE GIOCATA E', sempre nello stesso posto.
          Quando si sceglie, qui ci sono le due linguette. Quando NON si
          sceglie -- l'integrale nasce dalla struttura, due esiti sulla stessa
          partita, e non si puo' rifiutare -- le linguette sparivano e al loro
          posto non restava niente: il giocatore vedeva sparire Multipla e
          Sistema senza sapere perche' ne' che cosa sta giocando adesso.
          La parola sta dove stavano loro, con quante colonne ne escono, che
          e' la conseguenza che gli interessa. Il nome della partita NON ci
          va: era il messaggio di prima, e non si capiva. */}
      {integrale ? (
        <div className="lvc-sched-tipi">
          <span className="lvc-sched-tipo lvc-sched-tipo--unico" aria-current="true">
            {i18next.t('Integrale')}
            {tre && tre.colonne > 0 && (
              <em className="lvc-sched-tipo-quante">{tre.colonne}{' '}{i18next.t('colonne')}</em>
            )}
          </span>
        </div>
      ) : selezioni.length > 1 && (
        <div className="lvc-sched-tipi" role="tablist">
          {['multipla', 'sistema'].map((t) => (
            <button
              key={t}
              type="button"
              role="tab"
              className="lvc-sched-tipo"
              aria-selected={tipo === t}
              onClick={() => setTipoScelto(t)}
            >
              {t === 'multipla' ? i18next.t('Multipla') : i18next.t('Sistema')}
            </button>
          ))}
        </div>
      )}

      {/* SCORRE TUTTO QUELLO CHE STA SOPRA AI SOLDI, selezioni e tabella del
          sistema insieme. Prima scorrevano solo le selezioni, e la tabella
          si prendeva l'altezza che voleva: su uno schermo da 700 punti
          l'area delle partite si riduceva a ZERO -- misurata, zero -- e le
          partite sparivano del tutto. Un contenitore solo che scorre non ha
          questo problema, a qualunque altezza. */}
      <div className="lvc-sched-scorre">
        <div className="lvc-sched-selezioni">
          {selezioni.map((evento) => (
          <RigaEvento
            key={evento.eventId}
            evento={evento}
            fisse={fisseVive}
            /* La B solo sul sistema: altrove non vuol dire niente. */
            mostraFisse={tipo === 'sistema'}
            onTogli={onTogli}
            onFissa={(chiave) => setFisse((p) => (p.indexOf(chiave) === -1
                ? p.concat([chiave])
                : p.filter((c) => c !== chiave)))}
          />
          ))}
        </div>

        {tipo === 'sistema' && (
          <TabellaSistema
          quote={quote}
          chiaviFisse={fisseVive}
          scalini={scalini}
          giorniBonus={giorniBonus}
          attive={attiveVive}
          importi={importiSistema}
          onAttiva={(k) => setAttive((p) => (p.indexOf(k) === -1
              ? p.concat([k])
              : p.filter((x) => x !== k)))}
            onImporto={(k, v) => {
              /* Scritto a mano su UNA riga: il campo del totale non puo'
                 restare a dire un numero che non e' piu' vero, e non deve
                 nemmeno rispalmare cancellando quello che si e' appena
                 scritto. Quindi si ricalcola dalla realta' -- la somma di
                 quello che c'e' nelle righe -- e si marca come gia'
                 spalmato, cosi' l'effetto qui sopra sta fermo. */
              const aggiornati = Object.assign({}, importiSistema, { [k]: v });
              setImportiSistema(aggiornati);
              /* Scritto a mano, quella riga non ha piu' centesimi avanzati:
                 l'importo per colonna e' quello, per tutte le sue colonne. */
              const centesimiOra = Object.assign({}, centesimi, { [k]: 0 });
              setCentesimi(centesimiOra);
              const somma = attiveVive
                  .map((g) => totaleRiga(
                      Number(aggiornati[g]) || 0,
                      quanteCombinazioni(quote.length, fisseVive.length, g),
                      centesimiOra[g] || 0))
                  .reduce((a, b) => a + b, 0);
              const vero = somma > 0 ? String(arrotonda(somma)) : '';
              ultimaSpalmata.current = `${vero}|${colonneSpuntate}|${attiveVive.join(',')}`;
              setImportoTotale(vero);
            }}
          />
        )}
      </div>

      <BloccoSoldi
        quota={quotaSemplice}
        importo={importo}
        bonus={bonusSemplice}
        vincita={vincitaSemplice}
        tre={tre}
        passo={passo}
        troppoGrande={troppoGrande}
        selezioniDaScrivere={selezioniDaScrivere}
        tettoScritture={tettoScritture}
        importiRapidi={(profilo && profilo.importiRapidi) || []}
        onImporto={setImporto}
        tetto={appiattito}
        /* La casella dell'importo si segna quando e' l'importo a dover
           scendere o salire: importo o vincita sopra un tetto del banco
           chiuso. Non per le partite o le quote, che si sistemano altrove. */
        importoFuori={sforati.some((t) => t.quale === 'IMPORTO_MAX'
            || t.quale === 'IMPORTO_MIN' || t.quale === 'VINCITA_MAX')}
        /* La riga dei massimi sotto l'importo. Quando c'e' la striscia del
           banco chiuso, i tetti della notte li scrive lei: qui restano gli
           altri, se ce ne sono -- gli stessi numeri non si scrivono due
           volte. */
        massimi={striscia ? massimi.filter((m) => !m.dellaNotte) : massimi}
        perColonna={tipo === 'sistema'}
        integrale={integrale}
        importoTotale={importoTotale}
        colonneSpuntate={colonneSpuntate}
        onImportoTotale={(v) => setImportoTotale(v)}
      />

      <div style={{ padding: '0 16px 16px' }}>
        {/* L'esito dell'invio: il codice della giocata quando e' andata, e
            quando non e' andata il messaggio PIU' il codice dell'errore --
            il numero da solo non dice niente a chi guarda. */}
        {esito && (
          <div className={'lvc-sched-avviso lvc-sched-avviso--'
              + (esito.buona ? (esito.attesa ? 'riserva' : 'fatta') : 'blocco')}>
            {esito.testo}
          </div>
        )}

        {/* LA STRISCIA DEL BANCO CHIUSO sta sopra gli altri avvisi e sopra il
            tasto, nel blocco che non scorre: sul telefono si legge senza
            scorrere, con le selezioni che passano sopra. Solo se la skin ha
            scelto di dire «Banco chiuso» (modi 2 e 3): nel modo di serie i
            tetti della notte stanno nella riga dei massimi, come di giorno. */}
        {striscia && (
          <RigaBancoChiuso
            riapre={notte.riapre}
            tetti={notte.tetti}
            aColonne={Boolean(tre)}
          />
        )}

        {avvisi.filter((a) => !a.muto).map((a, i) => (
          <div
            key={i}
            className={`lvc-sched-avviso lvc-sched-avviso--${a.tipo}`}
          >
            {/* Dentro un elemento solo: l'avviso e' una riga flessibile, e
                una frase con un numero in grassetto in mezzo verrebbe
                disposta come tre colonne affiancate. */}
            <span>{a.testo}</span>
          </div>
        ))}

        <div className="lvc-sched-azioni">
          <button
            type="button"
            className="lvc-sched-conferma"
            disabled={!primario.attivo}
            onClick={primario.onClick || undefined}
          >
            {primario.testo}
          </button>

          {/* LA FRASE DEL BONUS INDICATIVO, e si accende dal backoffice.
              Per un ospite i numeri sono quelli della skin: la sua agenzia
              potrebbe avere una tabella sua. E' vero, ma raffredda, quindi la
              dice solo chi ha deciso di dirla -- spenta, si tace. */}
          {chi === 'ospite' && profilo && profilo.avvisoBonusIndicativo && scalini.length > 0 && (
            <div className="lvc-sched-nota-bonus">
              {i18next.t('Il bonus è indicativo fino all’accesso.')}
            </div>
          )}

          {chi === 'ospite' ? (
            <button type="button" className="lvc-sched-seconda" onClick={onGioca}>
              {i18next.t('Entra e gioca')}
            </button>
          ) : prenotabile && !nonGioca && (
            /* Non qui per chi non gioca: la prenotazione e' gia' il pulsante
               principale, e ripeterla sarebbe lo stesso gesto due volte. */
            <button type="button" className="lvc-sched-seconda" onClick={prenota}
              disabled={!importoScritto || inCorso}>
              {i18next.t('Prenota invece di giocare')}
            </button>
          )}

          {/* La conferma e' piena e larga, lo svuotamento e' un link sottile
              dall'altra parte. Regola scritta nel sistema di design, nata
              proprio da questa schedina: PLAY e RESET erano gemelli. */}
          <button type="button" className="lvc-sched-svuota" onClick={onSvuota}>
            {i18next.t('Svuota la schedina')}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ======================================================================
   LA STRISCIA DEL BANCO CHIUSO

   COSA FA
     Quando il banco della skin e' chiuso E la skin ha scelto di dirlo a chi
     gioca (Impostazioni schedina, tendina 7: «Banco chiuso e i limiti» o
     «Banco chiuso, i limiti e l'ora») scrive, mentre si compila, i tetti che
     valgono ADESSO e -- nel terzo modo -- l'ora in cui il banco riapre. Dice
     solo quello che di notte e' diverso dal giorno: i limiti che il servizio
     ha segnato (`tettoABancoChiuso`), coi suoi numeri. L'ora e' nel fuso di
     chi guarda, con la sigla, come le altre ore del sito. Vale uguale per
     l'agenzia che compila per un suo giocatore: chiuso e' chiuso per tutti.

   COSA NON FA
     Non compare nel modo di serie, «solo i limiti»: li' i tetti della notte
     stanno nella riga dei massimi sotto l'importo, come di giorno, e il
     giocatore non legge «Banco chiuso». Non compare se per quel giocatore di
     notte non cambia niente. Non dice chi ha chiuso ne' perche'. Non dice
     l'ora se la skin non ha scelto il terzo modo: il servizio non la manda
     proprio -- qui non c'e' niente da nascondere. Non dice mai quando il
     banco CHIUDE. Non promette che alla riapertura la giocata passi: di
     giorno sopra quella soglia la guarda una persona. Non scrive i vincoli
     mirati (un mercato, un evento, una fascia di quota): quelli la schedina
     non li conosce nemmeno di giorno, e fermano all'invio col motivo scritto.
   ====================================================================== */
function RigaBancoChiuso({ riapre, tetti, aColonne }) {
  const ora = riapre ? formattaOra(riapre, 'ora') : '';
  const sigla = ora ? siglaFuso(riapre) : '';
  const massimi = tetti.filter((t) => t.verso === 'max');
  const minimi = tetti.filter((t) => t.verso === 'min');

  /* Ogni voce resta intera sulla sua riga: «10» in fondo a una riga e
     «partite» da sola in quella dopo si legge male, e un importo spezzato
     peggio. A capo si va fra una voce e l'altra. */
  const elenco = (voci) => voci.map((t, i) => (
    <React.Fragment key={t.quale}>
      {i > 0 ? ' \u00b7 ' : ''}
      <span className="lvc-sched-banco-voce">{voceTetto(t, aColonne)}</span>
    </React.Fragment>
  ));

  return (
    <div className="lvc-sched-avviso lvc-sched-avviso--banco" role="status">
      {/* La luna, non un triangolo: non e' un errore e non e' un pericolo, e'
          un orario. Il colore da solo non lo direbbe a chi non lo distingue. */}
      <svg
        className="lvc-sched-banco-segno"
        width="15" height="15" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
      >
        <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
      </svg>
      <div>
        <b>{i18next.t('Banco chiuso')}</b>
        {ora && (
          <>
            {i18next.t(' · riapre alle ')}
            <b>{ora}</b>
            {sigla ? ` ${sigla}` : ''}
          </>
        )}
        {massimi.length > 0 && (
          <>
            <br />
            {i18next.t('Adesso si gioca fino a: ')}
            {elenco(massimi)}
          </>
        )}
        {minimi.length > 0 && (
          <>
            <br />
            {massimi.length > 0 ? i18next.t('E a partire da: ') : i18next.t('Adesso si gioca a partire da: ')}
            {elenco(minimi)}
          </>
        )}
      </div>
    </div>
  );
}

const partite = (n) => (Number(n) === 1 ? 'partita' : 'partite');

/** Un tetto, come sta scritto nella riga del banco chiuso. */
function voceTetto(t, aColonne) {
  const n = Number(t.valore);
  switch (t.quale) {
    case 'IMPORTO_MAX':
    case 'IMPORTO_MIN':
      /* SEMPRE IL TOTALE: su sistemi e integrali la casella non e' il totale
         della giocata, e senza dirlo «importo 500» si legge «per colonna». */
      return <>{i18next.t('importo')}{' '}<b>{euro(n)} €</b>{aColonne ? i18next.t(' in tutto') : ''}</>;
    case 'IMPORTO_MIN_COLONNA':
      return <><b>{euro(n)} €</b>{' '}{i18next.t('per colonna')}</>;
    case 'VINCITA_MAX':
      return <>{i18next.t('vincita')}{' '}<b>{euro(n)} €</b></>;
    case 'EVENTI_MAX':
    case 'EVENTI_MIN':
      return <><b>{n}</b> {partite(n)}</>;
    case 'QUOTA_MAX_SELEZIONE':
    case 'QUOTA_MIN_SELEZIONE':
      return <>{i18next.t('quota')}{' '}<b>{mostraQuota(n)}</b>{' '}{i18next.t('per selezione')}</>;
    case 'QUOTA_MAX_TOTALE':
    case 'QUOTA_MIN_TOTALE':
      return <>{i18next.t('quota totale')}{' '}<b>{mostraQuota(n)}</b></>;
    default:
      return null;
  }
}

/**
 * La riga che spiega perche' il tasto e' spento: quale massimo (o minimo) si
 * sta sforando, quanto vale, e cosa si puo' fare.
 *
 * Due registri. Di giorno, e a banco chiuso nel modo «solo i limiti», la
 * riga ha il nome della riga sotto l'importo e basta: «Importo massimo
 * 500,00 €: riduci l'importo.» -- il giocatore non sa che e' la notte. Con
 * la striscia del banco chiuso (`adesso`) la riga dice «Adesso l'importo
 * massimo e' 500,00 €...», e «oppure riprova dalle...» c'e' solo se il banco
 * ha un'ora di riapertura E la skin ha scelto di dirla (il terzo modo).
 */
function fraseTetto(t, riapreAlle, aColonne, adesso) {
  const n = Number(t.valore);
  const poi = riapreAlle ? `, oppure riprova dalle ${riapreAlle}.` : '.';
  const inTutto = aColonne ? ' in tutto' : '';
  switch (t.quale) {
    case 'IMPORTO_MAX':
      return adesso
        ? <>{i18next.t('Adesso l’importo massimo è')}{' '}<b>{euro(n)} €</b>{inTutto}{i18next.t(': riduci l’importo')}{poi}</>
        : <>{i18next.t('Importo massimo')}{' '}<b>{euro(n)} €</b>{inTutto}{i18next.t(': riduci l’importo')}{poi}</>;
    case 'IMPORTO_MIN':
      return adesso
        ? <>{i18next.t('Adesso l’importo minimo è')}{' '}<b>{euro(n)} €</b>{inTutto}{i18next.t(': alza l’importo')}{poi}</>
        : <>{i18next.t('Importo minimo')}{' '}<b>{euro(n)} €</b>{inTutto}{i18next.t(': alza l’importo')}{poi}</>;
    case 'VINCITA_MAX':
      return adesso
        ? <>{i18next.t('Adesso la vincita massima è')}{' '}<b>{euro(n)} €</b>{i18next.t(': riduci l’importo')}{poi}</>
        : <>{i18next.t('Vincita massima')}{' '}<b>{euro(n)} €</b>{i18next.t(': riduci l’importo')}{poi}</>;
    case 'EVENTI_MAX':
      return adesso
        ? <>{i18next.t('Adesso si giocano al massimo')}{' '}<b>{n}</b> {partite(n)}{i18next.t(': togline qualcuna')}{poi}</>
        : <>{i18next.t('Massimo')}{' '}<b>{n}</b> {partite(n)}{i18next.t(': togline qualcuna')}{poi}</>;
    case 'EVENTI_MIN':
      return adesso
        ? <>{i18next.t('Adesso servono almeno')}{' '}<b>{n}</b> {partite(n)}{i18next.t(': aggiungine')}{poi}</>
        : <>{i18next.t('Servono almeno')}{' '}<b>{n}</b> {partite(n)}{i18next.t(': aggiungine')}{poi}</>;
    case 'QUOTA_MIN_SELEZIONE':
      return adesso
        ? <>{i18next.t('Adesso la quota minima di una selezione è')}{' '}<b>{mostraQuota(n)}</b>{i18next.t(': togli quelle più basse')}{poi}</>
        : <>{i18next.t('Quota minima di una selezione')}{' '}<b>{mostraQuota(n)}</b>{i18next.t(': togli quelle più basse')}{poi}</>;
    case 'QUOTA_MAX_SELEZIONE':
      return adesso
        ? <>{i18next.t('Adesso la quota massima di una selezione è')}{' '}<b>{mostraQuota(n)}</b>{i18next.t(': togli quelle più alte')}{poi}</>
        : <>{i18next.t('Quota massima di una selezione')}{' '}<b>{mostraQuota(n)}</b>{i18next.t(': togli quelle più alte')}{poi}</>;
    default:
      return null;
  }
}

/**
 * Il riassunto di un sistema dove ogni grandezza ha il suo importo.
 *
 * Non si puo' usare `riassunto` cosi' com'e' perche' li' l'importo e' uno
 * solo: qui una quaterna e una cinquina possono valere cifre diverse.
 */
/** Una copia della mappa senza le chiavi elencate. */
function scarta(mappa, chiavi) {
  if (!chiavi || chiavi.length === 0) return mappa;
  const nuova = Object.assign({}, mappa);
  chiavi.forEach((k) => { delete nuova[k]; });
  return nuova;
}

function riassuntoMisto(colonneConImporto, scalini, giorniMassimi) {
  let quotaMin = null; let quotaMax = null;
  let bonusMin = 0; let bonusMax = 0; let bonusTutte = 0;
  let vincitaMin = null; let vincitaMax = null; let vincitaTutte = 0;
  let quotaTutte = 0; let importoTotale = 0;

  colonneConImporto.forEach(({ colonna, importo: suo }) => {
    const importo = Number(suo) || 0;
    const valori = colonna.map((q) => q.valore);
    const quota = valori.reduce((a, b) => a * b, 1);
    const bonus = bonusColonna(quota, importo,
        quoteCheContano(colonna, giorniMassimi), scalini);
    const vincita = arrotonda(quota * importo) + bonus;

    quotaTutte += quota;
    bonusTutte += bonus;
    vincitaTutte += vincita;
    importoTotale += importo;

    if (quotaMin === null || quota < quotaMin) { quotaMin = quota; bonusMin = bonus; vincitaMin = vincita; }
    if (quotaMax === null || quota > quotaMax) { quotaMax = quota; bonusMax = bonus; vincitaMax = vincita; }
  });

  return {
    colonne: colonneConImporto.length,
    quotaMin: arrotonda(quotaMin), quotaMax: arrotonda(quotaMax),
    quotaTutte: arrotonda(quotaTutte),
    bonusMin, bonusMax, bonusTutte: arrotonda(bonusTutte),
    vincitaMin: arrotonda(vincitaMin), vincitaMax: arrotonda(vincitaMax),
    vincitaTutte: arrotonda(vincitaTutte),
    importoTotale: arrotonda(importoTotale),
  };
}
